import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const QuantityWrapper = styled.div`
  width: ${props => props.theme.basketItem.quantity.width};
  font-size: ${props => props.theme.basketItem.quantity.fontSize};
  color: ${p => p.theme.basketItem.quantity.color};
  display: flex;
  box-sizing: content-box;
  ${media.small`
    width: 100%;
  `}
`;

export const QuantityBlock = styled.div`
  width: ${props => props.theme.basketItem.quantity.block.size};
  height: ${props => props.theme.basketItem.quantity.block.size};
  cursor: ${props => props.nonClickable ? 'initial' : 'pointer'};
  background-color: ${props => props.theme.basketItem.quantity.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  ${media.small`
    width: 100%;
  `}
  &:hover {
    background-color: ${props => props.nonClickable ? props.theme.basketItem.quantity.backgroundColor : props.theme.basketItem.selected.color};
    color: ${p => p.nonClickable ? p.theme.basketItem.quantity.color : p.theme.basketItem.quantity.hoverColor};
    border-radius: 0.6rem;
  }
`;



// WEBPACK FOOTER //
// ./components/Quantity/Quantity.style.js